import { DateTime } from 'luxon';

const CHATWOOT_SUPPORT = '551150268942';
const CHATWOOT_SALES = '5511935033168';
const INSURANCE_SAULO = '5511935027692';
const CANCEL_ANA_PAULA = '5519935012478';
const SALES_RONAN = '5511991825107';

export const supportPhoneNumber = CHATWOOT_SUPPORT;

export const coldSalesPhoneNumber = CHATWOOT_SALES;

export const insuranceSupportPhoneNumber = INSURANCE_SAULO;

export const cancelSubscriptionPhoneNumber = CHATWOOT_SUPPORT;

export const rentAdvanceHelpPhoneNumber = SALES_RONAN;

const aludebrasil = 'aludebrasil';

export const whatsappBase = `https://api.whatsapp.com/send`;

export const whatsappInsuranceSupport = `${whatsappBase}?phone=${insuranceSupportPhoneNumber}&text=Oi!%20Gostaria%20de%20fazer%20uma%20nova%20cotação%20de%20seguro%20fiança`;

export const whatsappCancelSubscription = `${whatsappBase}?phone=${cancelSubscriptionPhoneNumber}&text=Oi!%20Gostaria%20de%20cancelar%20minha%20assinatura%20de%20plano%20na%20Alude%20porque…`;

export const whatsappRentalSupport = `${whatsappBase}?phone=${supportPhoneNumber}`;

export const whatsappColdSales = `${whatsappBase}?phone=${coldSalesPhoneNumber}`;

export const whatsappCheckoutSales = `${whatsappBase}?phone=${coldSalesPhoneNumber}&text=Oi%21%20Estou%20interessado%20em%20saber%20mais%20sobre%20os%20preços%20da%20Alude`;

export const whatsappRentAdvanceHelp = `${whatsappBase}?phone=${rentAdvanceHelpPhoneNumber}&text=Oi,%20gostaria%20de%20saber%20mais%20sobre%20antecipação%20de%20aluguel`;

export const livechatSupport = `${whatsappBase}?phone=${supportPhoneNumber}`;

const instagramUrl = 'https://www.instagram.com';

const facebookUrl = 'https://www.facebook.com';

const linkedinUrl = 'https://www.linkedin.com';

export const serviceTermsUrl =
    'https://media.alude.com.br/termos-de-uso-de-politica-de-privacidade-e-de-tratamento-de-dados-pessoais-20240802.pdf';

export const instagramAlude = `${instagramUrl}/${aludebrasil}`;

export const facebookAlude = `${facebookUrl}/${aludebrasil}`;

export const linkedInAlude = `${linkedinUrl}/company/aludealugueldescomplicado/`;

export const aludeCopyright = `Copyright © ${
    DateTime.now().year
} Alude Tecnologia LTDA`;

export const aludeCNPJ = '32.098.856/0001-38';

export const aludeAddress =
    'R Dr Guilherme Bannitz, 126, CJ 12 1º andar, Itaim Bibi CEP 04.532-060. São Paulo/SP';
